import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { debounce } from 'lodash';
import { useState, useEffect } from 'react';
import icon from 'images/utility-icons/search.svg';
import Results from './Results';
import ResultsWrapper from './ResultsWrapper';
function PracticeSearchForm({ handleSubmit, clearPracticeLocations, getPracticeLocations, practiceLocations, setPracticeLocations, useStyle = true, displayOptions = {
    showPrequalify: true,
    placeholder: 'Practice Name, Address, or Phone Number',
}, }) {
    // State
    const [practiceLocationSuggestions, setPracticeLocationSuggestions] = useState([]);
    // Func - submit
    const onSubmit = (e) => {
        e.preventDefault();
        handleSubmit(e);
    };
    // Func - click
    const handleClick = (item) => {
        handleSubmit(item);
    };
    // Debounce
    const getPracticeLocationsDebounced = debounce((queryType, value) => {
        getPracticeLocations(queryType, value);
    }, 500);
    // Effects
    useEffect(() => {
        clearPracticeLocations();
    }, []);
    useEffect(() => {
        setPracticeLocationSuggestions(practiceLocations);
    }, [practiceLocations]);
    const findPractice = (e) => {
        if (e.target.value && e.target.value != '') {
            getPracticeLocationsDebounced('all', e.target.value);
        }
        else {
            setPracticeLocations([]);
        }
    };
    return (_jsx("form", { className: "results", noValidate: true, onSubmit: onSubmit, children: _jsxs("div", { className: "practice-search-wrapper", style: { zIndex: 1000 }, children: [_jsx("img", { src: icon, className: "magGlass", alt: "search" }), _jsx("input", { name: "searchCriteria", placeholder: displayOptions.placeholder, onChange: findPractice, type: "search" }), _jsx(ResultsWrapper, { useStyle: useStyle, children: _jsx(Results, { handleClick: handleClick, results: practiceLocationSuggestions, showPrequalify: displayOptions.showPrequalify }) })] }) }));
}
export default PracticeSearchForm;
